import { useNavigate } from "react-router-dom";
import { Button } from "@porchpass/ui";
import { useAuth } from "src/context";
import { useToast } from "src/components/Toast";
import {
  Container,
  LogoContainer,
  BackgroundGradient,
  CenteredContainer,
  Title,
  SubTitle,
} from "./LoginPage.styles";
import { Footer } from "./Footer";
import { Logo } from "src/components/Logo";
import { usePageView } from "src/hooks/usePageView";

export default () => {
  const { signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const { setPendingToast } = useToast();
  usePageView("Login");

  const handleGoogleSignIn = () => {
    signInWithGoogle()
      .then(() => navigate("/pre-approval"))
      .catch((error: Record<string, any>) => {
        console.error("Google sign-in error:", error);
        setPendingToast(
          (error.message as string) || "Failed to sign in with Google",
          "error",
        );
      });
  };

  const titleText = "Welcome to PorchPass";
  const subTitleText = "To get started, please sign in";
  return (
    <Container>
      <BackgroundGradient />
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <CenteredContainer>
        <Title>{titleText}</Title>
        <SubTitle>{subTitleText}</SubTitle>
        <div>
          <Button size="s" onClick={handleGoogleSignIn}>
            Sign in with Google
          </Button>
        </div>
      </CenteredContainer>
      <Footer />
    </Container>
  );
};
